/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsFilterBase {
    getFixupPrototypeFunction() { return AppSecopsFilterBase.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsFilterBase>): AppSecopsFilterBase {
        let obj = Object.assign(new AppSecopsFilterBase(), model);
        AppSecopsFilterBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsFilterBase>): AppSecopsFilterBase {
        if (!model) return null;
        return AppSecopsFilterBase.newInstance(<AppSecopsFilterBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsFilterBase) {
        if (!obj) return;

        models.AppSecopsFilterBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsFilterBase): boolean {
        Object.setPrototypeOf(obj, AppSecopsFilterBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the portfolio/application/project
     */
    name: Array<string>;

    /**
     * Tags for Portfolio/Application/project
     */
    tags: Array<models.KeyValuePair>;

    /**
     * Tenant ID
     */
    tenant_id: string;

}
